import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';

export function getAssistentConfigSonstige(customCfg?: any): AssistentItem {
    const eingabe_sonstige = {
        gliederung: '7.',
        name: 'Erfasser:in',
        description: 'Dies ist das Formular zur Eingabe der Daten der Erfasser:innen.',
        type: 'EntityForm',
        entity: IDs.ENT_SONSTIGE_DATEN,
        singleItem: true,
        configFlag: 'inputSonstige',
        ...(customCfg || {})
    };
    return eingabe_sonstige;
}
